import ProduitEcranCible from "../../domain/ProduitEcranCible";

export const generationAlpha = new ProduitEcranCible('cta', 'Cine Target Génération \u03B1', 'Entrées Génération \u03B1', {
  'S2001': {audience: 307551, tarif: 242040},
  'S2002': {audience: 205922, tarif: 105340},
  'S2003': {audience: 208465, tarif: 106640},
  'S2004': {audience: 270425, tarif: 138340},
  'S2005': {audience: 321799, tarif: 291240},
  'S2006': {audience: 432980, tarif: 408910},
  'S2007': {audience: 406600, tarif: 415990},
  'S2008': {audience: 404122, tarif: 413460},
  'S2009': {audience: 347602, tarif: 300920},
  'S2010': {audience: 346275, tarif: 299770},
  'S2011': {audience: 283834, tarif: 201040},
  'S2012': {audience: 229532, tarif: 162580},
  'S2013': {audience: 305996, tarif: 240820},
  'S2014': {audience: 342804, tarif: 310250},
  'S2015': {audience: 299738, tarif: 271280},
  'S2016': {audience: 283995, tarif: 257030},
  'S2017': {audience: 463320, tarif: 474020},
  'S2018': {audience: 325246, tarif: 268770},
  'S2019': {audience: 269437, tarif: 190840},
  'S2020': {audience: 281362, tarif: 199290},
  'S2021': {audience: 345258, tarif: 298890},
  'S2022': {audience: 248777, tarif: 205580},
  'S2023': {audience: 399398, tarif: 314330},
  'S2024': {audience: 252627, tarif: 159050},
  'S2025': {audience: 313135, tarif: 197150},
  'S2026': {audience: 332675, tarif: 445090},
  'S2027': {audience: 421616, tarif: 431360},
  'S2028': {audience: 372828, tarif: 322760},
  'S2029': {audience: 378186, tarif: 357160},
  'S2030': {audience: 336376, tarif: 264730},
  'S2031': {audience: 333385, tarif: 262370},
  'S2032': {audience: 433234, tarif: 340960},
  'S2033': {audience: 299196, tarif: 235470},
  'S2034': {audience: 230656, tarif: 117990},
  'S2035': {audience: 289609, tarif: 159550},
  'S2036': {audience: 222564, tarif: 175160},
  'S2037': {audience: 226297, tarif: 187000},
  'S2038': {audience: 327697, tarif: 309480},
  'S2039': {audience: 309936, tarif: 292700},
  'S2040': {audience: 269387, tarif: 212010},
  'S2041': {audience: 226831, tarif: 178520},
  'S2042': {audience: 271299, tarif: 256210},
  'S2043': {audience: 383353, tarif: 392210},
  'S2044': {audience: 347567, tarif: 328240},
  'S2045': {audience: 259146, tarif: 224340},
  'S2046': {audience: 330134, tarif: 298790},
  'S2047': {audience: 309534, tarif: 280140},
  'S2048': {audience: 288812, tarif: 261390},
  'S2049': {audience: 283845, tarif: 335080},
  'S2050': {audience: 329668, tarif: 415120},
  'S2051': {audience: 487765, tarif: 633390},
  'S2052': {audience: 441032, tarif: 572700}
});

